/**
 * @generated SignedSource<<5c40e018d8ca191580a13d4276a961a1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftAvatarCircle_address$data = {
  readonly address: string | null;
  readonly publicProfile: {
    readonly avatarImage: {
      readonly path: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "NftAvatarCircle_address";
};
export type NftAvatarCircle_address$key = {
  readonly " $data"?: NftAvatarCircle_address$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftAvatarCircle_address">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftAvatarCircle_address",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PublicProfile",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Photo",
          "kind": "LinkedField",
          "name": "avatarImage",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EthereumAddressType",
  "abstractKey": null
};

(node as any).hash = "3c5e5588f4ce25fe6e7578b882cb3d33";

export default node;
